import PropTypes from 'prop-types';

import { FormSpacer, FormLegend, FormRequired, FormHint } from 'bloko/blocks/form';
import Text from 'bloko/blocks/text';

import 'components/ClickmeFormItem/ClickmeFormItem.less';

const ClickmeFormItem = ({
    input,
    legend,
    info,
    hint,
    after,
    warning,
    error,
    dataQa = '',
    isRequired = false,
    errorDataQa = '',
}) => (
    <div className="clickme-form-row">
        <div className="clickme-form-item">
            {legend && (
                <div className="clickme-form-item__legend ">
                    <FormLegend>
                        <Text Element="span" strong>
                            {legend}
                        </Text>
                        {isRequired && <FormRequired />}
                        {info && <FormSpacer>{info}</FormSpacer>}
                    </FormLegend>
                </div>
            )}
            {!legend && <div className="clickme-form-item__legend " />}
            <div className="clickme-form-item__input" data-qa={dataQa}>
                {input}
            </div>
        </div>
        {hint && (
            <div className="clickme-form-item__hint">
                <FormHint>{hint}</FormHint>
            </div>
        )}
        {warning && (
            <div className="clickme-form-item__hint">
                <div className="clickme-form-item__warning">{warning}</div>
            </div>
        )}
        {error && (
            <div className="clickme-form-item__hint">
                <div className="clickme-form-item__error" data-qa={errorDataQa}>
                    {error}
                </div>
            </div>
        )}
        {after && <div className="clickme-form-item__after">{after}</div>}
    </div>
);

ClickmeFormItem.propTypes = {
    input: PropTypes.node,
    legend: PropTypes.node,
    info: PropTypes.node,
    hint: PropTypes.node,
    isRequired: PropTypes.bool,
    after: PropTypes.node,
    warning: PropTypes.string,
    error: PropTypes.node,
    dataQa: PropTypes.string,
    errorDataQa: PropTypes.string,
};

export default ClickmeFormItem;
